import React, { useContext, Fragment, useEffect, useRef, useState } from 'react';
import { useMutation } from '@apollo/react-hooks';
import PageScrollContext from 'context/PageScrollContext';
import md5 from 'crypto-js/md5';
import {
	Page,
	Range,
	ColorPicker,
	FormGroup,
	Input,
	Textarea,
	FormControl,
	Dropdown,
	Switch,
	CustomText,
	Icon,
	Button,
	Alert,
	VideoModal,
	RichEditor,
	ButtonSelect,
	MultiCurrencyModeAlerts,
} from 'components';
import PreviewContext from 'context/PreviewContext';
import ShopContext from 'context/ShopContext';
import UserContext from 'context/UserContext';
import { GOOGLE_FONTS, CAMPAIGN_TYPES, SHOP_DEFAULT_SETTINGS, BREAK_POINTS } from 'lib/globals';
import { SAVE_SHOP_SETTINGS, UPDATE_SHOP_PROP } from 'lib/mutations';
import ExtraModules from 'screens/campaigns/settings/ExtraModules/index';
import CheckoutButton from 'screens/campaigns/settings/ExtraModules/CheckoutButton';
import { Loading, Toast, Modal } from '@shopify/app-bridge-react';
import { ShopConstraints } from 'Constraints';
import removeTypeName, { removeByType } from 'lib/removeTypeName';
import { Run } from 'lib/validate';
import { GET_SHOP_SETTINGS } from 'Queries';
import { PageHeader } from 'components/Page';
import { API, graphqlOperation } from 'aws-amplify';
import { APP_DEV } from 'aws-exports';
import Axios from 'axios';
import { Manager, Reference, Popper } from 'react-popper';
import Checkbox from 'react-simple-checkbox';
import { useTransition } from 'react-spring';
import _ from 'lodash';
import classNames from 'lib/classNames';
import useReactRouter from 'use-react-router';
import { SET_ALL } from 'reducers/SetItemReducer';
import useRefState from 'hooks/useRefState';
import {
	ScarcitySettings
} from './settings/scarcity'
import {
	TermsSettings
} from './settings/terms'

const CartScreen = (props) => {
	const {
		setCartIsEmpty,
		setCheckoutButtonLoadingEdit,
		campaign_preview_types,
	} = useContext(PreviewContext);
	const stickyAlert = useRef(null);
	const { history, location } = useReactRouter();
	const [scrollTop, setScrollTop, scrollTopRef] = useRefState();
	const [cartActivateLoading, setCartActivateLoading] = useState(false);
	const [videoOne, setVideoOne] = useState(false);
	const [googleFonts, setGoogleFonts] = useState([]);
	const [hideTopBar, setHideTopBar] = useState(false);
	const [showConfirmActivate, setShowConfirmActivate] = useState(false);
	const [campaign_preview_visible, setCampaign_preview_visible] = useState(false);
	const campaign_preview_content_ref = useRef(null);
	const shopContext = useContext(ShopContext);
	const user = useContext(UserContext);
	const { state, discard, validationErrors, setValidationErrors, dispatch, setItem } = shopContext;
	const { campaigns, draft_checkout_alerted, multi_currency_checkout_alerted } = state;
	// const filterSettings = (settings) =>
	// 	_.merge(
	// 		{},
	// 		SHOP_DEFAULT_SETTINGS(),
	// 		removeByType(
	// 			removeTypeName(
	// 				Object.fromEntries(Object.entries(settings).filter(([key]) => !['settingsSaved'].includes(key)))
	// 			),
	// 			(v) => v !== '' && v !== null
	// 		)
	// 	);

	const filterSettings = (settings) => {
		return removeByType(
			removeTypeName(
				Object.fromEntries(Object.entries(settings).filter(([key]) => !['settingsSaved'].includes(key)))
			),
			(v) => v !== '' && v !== null
		);

		return (
			_.mergeWith(
				SHOP_DEFAULT_SETTINGS(),
				removeByType(
					removeTypeName(
						Object.fromEntries(Object.entries(settings).filter(([key]) => !['settingsSaved'].includes(key)))
					),
					(v) => v !== '' && v !== null
				),
				(v) => v !== '' && v !== null
			),
			(objValue, srcValue) => (srcValue && _.isArray(srcValue) ? srcValue : undefined)
		);
	};

	let [saveShopSettings, { data, error, loading }] = useMutation(SAVE_SHOP_SETTINGS, {
		refetchQueries: [
			{
				query: GET_SHOP_SETTINGS,
				variables: {
					userId: user.attributes.website,
				},
			},
		],
	});
	const transitions = useTransition(!_.isEqual(state.original_settings, state.settings) && !hideTopBar, null, {
		from: { position: 'absolute', opacity: 0 },
		enter: { opacity: 1 },
		leave: { opacity: 0 },
		config: {
			duration: 300,
		},
	});
	const validate = (state, specific = []) =>
		Run(state, specific, {
			errors: validationErrors,
			setErrors: setValidationErrors,
			constraints: ShopConstraints,
		});
	const save = (assign = {}, checkRTL = true) => {
		// console.log("state")
		// console.log(state.settings)
		// return
		if (validate(state)) return;
		if (
			checkRTL &&
			Object.keys(state.original_settings || {}).length &&
			state.settings.rtl !== state.original_settings.rtl
		) {
			console.log('updating theme', state.settings.rtl, state.original_settings.rtl, state.settings.active);
			return activateCart(state.settings.active, true, state.settings.rtl);
		}
		saveShopSettings({
			variables: {
				id: user.attributes.website,
				input: filterSettings(Object.assign(state.settings, assign)),
			},
		});
	};

	const activateCart = async (active, confirmed = false, rtl = null) => {
		if (active && !confirmed && !state.settingsSaved && _.isEqual(SHOP_DEFAULT_SETTINGS, state.settings)) {
			return setShowConfirmActivate(true);
		}
		setCartActivateLoading(true);
		const { success } = await API.post('API_GATEWAY', '/cart/activate', {
			body: { active, rtl: rtl === null ? state.settings.rtl : rtl },
		});
		setCartActivateLoading(false);
		return save({ active }, false);
	};

	const handleOutSideClick = (event) => {
		if (!campaign_preview_content_ref.current) return;
		else if (campaign_preview_content_ref.current.contains(event.target)) return;
		setCampaign_preview_visible(false);
	};

	const toggle_type = (type, value) => {
		if (value) {
			campaign_preview_types.set([...new Set(campaign_preview_types.get.concat([type]))]);
		} else {
			campaign_preview_types.set(campaign_preview_types.get.filter((c) => c !== type));
		}
	};

	const type_is_active = (type) => {
		const typeIndex = campaign_preview_types.get.indexOf(type);
		return typeIndex !== -1 ? true : false;
	};



	useEffect(() => {
		if (campaign_preview_visible) document.addEventListener('mousedown', handleOutSideClick, false);
		else document.removeEventListener('mousedown', handleOutSideClick, false);
		return () => {
			document.removeEventListener('mousedown', handleOutSideClick, false);
		};
	}, [campaign_preview_visible]);

	useEffect(() => {
		// if (typeof state.settings.multiCurrencyMode !== 'boolean') {
		// 	setItem('settings.multiCurrencyMode', false);
		// }
		async function getGoogleFonts() {
			const { data } = await Axios.get(
				`https://www.googleapis.com/webfonts/v1/webfonts?sort=popularity&key=AIzaSyCYLq50twmAe1_7jITZuehrERZWOjNqBCY`
			);
			setGoogleFonts(
				data.items.map(({ family, variants }) => ({ label: family, value: `${family}:${variants.join()}` }))
			);
		}
		getGoogleFonts();
	}, []);

	const redirectToCheckoutSettings = (e) => {
		e.preventDefault();
		if (!scrollTopRef.current) return;
		const padding = 1.5 * parseFloat(getComputedStyle(document.documentElement).fontSize);
		scrollTopRef.current(
			document.getElementById(`id_${md5('checkout settings')}`).closest('.mu-group-wrapper').offsetTop - 0
		);
	};

	const IUnderstand = async (input) => {
		await API.graphql(
			graphqlOperation(UPDATE_SHOP_PROP, {
				id: user.attributes.website,
				input,
			})
		);
		Object.entries(input).forEach(([key, value]) => {
			setItem(key, value);
		});
	};

	useEffect(() => {
		setHideTopBar(!!data);
		if (APP_DEV) setTimeout(() => setHideTopBar(false), 1500);
	}, [data]);

	useEffect(() => {
		if (state.settings.cod_settings.checkout_mode == 'cod_and_checkout') {
			setItem('settings.cod_settings.is_form_in_cart', false);
		}
	}, [state.settings.cod_settings]);

	return (
		<Page
			background="none"
			getScrollTop={({ scrollTop }) => {
				console.log({ scrollTop });
				setScrollTop(scrollTop);
			}}
			padding={0}
			header={{
				title: 'Settings',
			}}
			TopContent={{
				transitions,
				render: () => (
					<Alert
						type="save_settings"
						title="unsaved changes"
						borderPosition="none"
						paddingX="px-6"
						actions={[
							{
								text: 'Discard',
								type: 'secondary',
								loading: false,
								onClick: () => discard(),
							},
							{
								text: 'Save',
								type: 'primary',
								loading: loading || cartActivateLoading,
								onClick: () => save(),
							},
						]}
					/>
				),
			}}
		>
			<Fragment>
				{data && (
					<Toast
						content="Cart settings has been saved"
						duration={3000}
						onDismiss={() => {
							setHideTopBar(false);
						}}
					/>
				)}
				{(loading || cartActivateLoading) && <Loading />}
				<Alert
					{...{
						forwardRef: stickyAlert,
						type: state.settings.active ? 'success' : 'warning',
						title: `custom cart is ${state.settings.active ? 'enabled' : 'disabled'}`,
						withSwitch: {
							context: [shopContext, 'settings.active', (value) => activateCart(value)],
						},
						icon: state.settings.active ? 'check-circle' : 'exclamation-circle',
					}}
					className="z-5"
				>
					{state.settings.active && (
						<p>
							Cart button not working? Click to{' '}
							<span
								href="#"
								className={classNames('font-bold underline cursor-pointer')}
								onClick={() => {
									history.push('/settings/setup' + location.search);
								}}
							>
								manually setup
							</span>
						</p>
					)}
					{!state.settings.active && <p>Customize default cart settings / visuals and set it live.</p>}
				</Alert>

				{campaigns.length === 0 && (
					<Alert
						{...{
							type: 'warning',
							borderPosition: 'border-l-4',
							iconSize: '2x',
							title: 'Create your first campaign',
							icon: 'exclamation-circle',
							customStyle: {
								icon: 'text-orange-400 self-start mt-1',
							},
						}}
						className="my-6 z-5"
					>
						<p>Visit Campaign Page To Create Your 1st Upsell Campaign.</p>
						<div className={classNames('flex space-x-3 pt-3 justify-start')}>
							<a
								className={classNames(
									'text-gray-800 text-sm flex items-center hover:text-orange-500 focus:outline-none focus:outline-shadow font-semibold py-1 px-2 uppercase border bg-orange-200 bg-opacity-50 border-orange-300 rounded'
								)}
								onClick={() => history.push('campaigns/create' + location.search)}
							>
								<Icon icon="info-circle" className="mr-2" size="1x" />
								<span className={classNames('text-xs')}>Create campaign</span>
							</a>
						</div>
					</Alert>
				)}

				<Modal
					title="Activating custom cart"
					message="You're about to activate the cart with the default settings"
					open={!!showConfirmActivate}
					primaryAction={{
						content: 'Activate',
						destructive: true,
						onAction: () => {
							setShowConfirmActivate(false);
							activateCart(true, true);
						},
					}}
					secondaryActions={[
						{
							content: 'Cancel',
							onAction: () => {
								setShowConfirmActivate(false);
								discard();
							},
						},
					]}
				/>
				<MultiCurrencyModeAlerts {...{ ...state, redirectToCheckoutSettings, IUnderstand }} />

				<FormGroup label="theme settings" info="Customize the main cart settings">
					<FormControl label="Default language">
						<Dropdown
							options={[
								{ value: 'english', label: 'English' },
								{ value: 'french', label: 'Français' },
								{ value: 'german', label: 'German' },
								{ value: 'arabic', label: 'العربية' },
							]}
							first
							autoFocus={true}
							BindToContext={[
								shopContext,
								'settings.default_language',
								(language) => {
									dispatch({
										type: SET_ALL,
										value: {
											...state,
											settings: SHOP_DEFAULT_SETTINGS(language),
										},
									});
								},
								'settings',
							]}
						/>
					</FormControl>
					<FormControl label="Colors" error={validationErrors['settings.theme.background']}>
						<ColorPicker text="background" BindToContext={[shopContext, 'settings.theme.background']} />
					</FormControl>
					<FormControl
						label="default font size"
						info="This font effects all other cart font sizes"
						error={validationErrors['settings.font.size']}
					>
						<Input
							type="number"
							icon={{ char: 'PX' }}
							max={18}
							min={12}
							BindToContext={[shopContext, 'settings.font.size']}
							hasError={!!validationErrors['settings.font.size']}
						/>
					</FormControl>
					<FormControl
						label="font family"
						withSwitch={[shopContext, 'settings.font.custom']}
						info="By default the cart will use your store theme font. Turn this section on to add a custom google font."
					>
						<Dropdown
							disabled={!state.settings.font.custom || !googleFonts.length}
							options={googleFonts}
							first
							BindToContext={[shopContext, 'settings.font.family']}
						/>
					</FormControl>
					<FormControl
						label="display cart on RTL"
						withSwitch={[shopContext, 'settings.rtl']}
						info="Enable this if your store language uses right to left scripts."
					/>
				</FormGroup>
				<FormGroup label="header settings">
					<CustomText
						context={shopContext}
						label="cart title"
						path="settings.header.title"
						// info="The em unit is relative to the font size (2em means 2 times the current font size)"
					/>
					<FormControl label="header colors" error={validationErrors['settings.header.background']}>
						<ColorPicker text="text" BindToContext={[shopContext, 'settings.header.title.color']} />
						<ColorPicker text="background" BindToContext={[shopContext, 'settings.header.background']} />
					</FormControl>
				</FormGroup>
				<FormGroup label="cart setup" info="Design the basic cart visuals">
					<CustomText
						context={shopContext}
						label="product title"
						path="settings.product.title"
						hasColor={true}
					/>
					<CustomText
						context={shopContext}
						label="product price"
						path="settings.product.price"
						hasColor={true}
					/>
					<FormControl
						label="product image size"
						info="an integer between 50 and 120"
						error={validationErrors['settings.product.image_size']}
					>
						<Input
							type="number"
							BindToContext={[shopContext, 'settings.product.image_size']}
							min={50}
							max={120}
						/>
					</FormControl>
					<FormControl
						label="lower checkout button"
						info="Checkout button will sit at the bottom of screen unless products push it lower."
						error={validationErrors['settings.product.grow']}
					>
						<Switch BindToContext={[shopContext, 'settings.product.grow']} />
					</FormControl>
					<FormControl
						label="Add to cart opens Cart"
						info="Every time a customer adds to cart the slide cart will appears. (We recommended leaving this on.)"
						error={validationErrors['settings.open_cart']}
					>
						<Switch BindToContext={[shopContext, 'settings.open_cart']} />
					</FormControl>
					<FormControl label="sold out" error={validationErrors['settings.product.sold_out']}>
						<Input
							type="text"
							BindToContext={[shopContext, 'settings.product.sold_out', null, 'settings']}
							hasError={!!validationErrors['settings.product.sold_out']}
						/>
					</FormControl>
					<FormControl
						label="empty cart"
						info={`Displayed when no products are in the cart.
						Tip: you can add images`}
					>
						<RichEditor
							placeholder="empty cart text"
							BindToContext={[shopContext, 'settings.empty_cart']}
							onFocus={() => {
								setCartIsEmpty(true);
							}}
							onBlur={(editor, activeElement) => {
								if (!editor.contains(activeElement)) setCartIsEmpty(false);
							}}
						/>
					</FormControl>
				</FormGroup>
				<CheckoutButton context={shopContext} setCheckoutButtonLoadingEdit={setCheckoutButtonLoadingEdit} />
			
				<ScarcitySettings  {...{shopContext}}/>
				<TermsSettings {...{shopContext}}/>

				<FormGroup label="Custom CSS">
					<FormControl   
						label="Manually Add Custom CSS Changes To The Cart." 
						info={`This is helpful if you need to modify text sizes and introduce small branding elements.
						Reach out to the team if you need help finding specific id's. Styles will only be applied to live cart on your store not in dashboard preview. 
						(Advanced users only)`
							}
					> 
						<Textarea
							BindToContext={[shopContext, 'settings.custom_css']}
							placeholder=".text{ color: blue; }"
						/>
					</FormControl>
				</FormGroup>

				

				{!BREAK_POINTS['kill_draft'](shopContext) && (
					<FormGroup
						label="checkout settings"
						info={`
					<p class="${classNames('mb-1')}">To navigate Shopify’s limited discount functionalities we use draft discounts.</p>
					<h4 class="${classNames('font-bold text-gray-600 mb-1')}">Draft checkout:</h4>
					<p>has more discount functionality and is preferred option for upsells.</p>
					<h4 class="${classNames('font-bold text-gray-600 mb-1')}">Normal Shopify checkout:</h4>
					<p>works better for stores that sell in multi-currency and want customers to add discounts in checkout area.</p>
					`}
					>
						<ButtonSelect
							isVertical
							options={[
								{
									label: 'Draft Checkout',
									value: false,
									infoHtml: true,
									info: `
							<ul class="${classNames('list-disc list-inside')}">
								<li>Allow multiple discounts</li>
								<li>More powerful campaign options</li>
								<li>Checkout is in default store currency</li>
								<li>Coupon must be added in upsell cart</li>
							</ul>
							`,
								},
								{
									label: 'Normal Shopify Checkout',
									value: true,
									infoHtml: true,
									info: `
								<ul class="${classNames('list-disc list-inside')}">
								<li>One discount at a time</li>
								<li>Uses unique discount codes injected at checkout</li>
								<li>Checkout is in Multi-currency</li>
								<li>Coupons added in checkout like normal</li>
							</ul>
							`,
								},
							]}
							BindToContext={[shopContext, 'settings.multiCurrencyMode']}
						/>
					</FormGroup>
				)}

				{/* // COD */}
				<FormGroup
					label="Cash On Delivery Checkout"
					info={`<p>Replace standard Shopify checkout process with our fully customizable COD checkout.</p>`}
				>
					<ButtonSelect
						isVertical
						options={[
							{
								label: 'Cash On Delivery Checkout - COD ( Shopify will not take any payments)',
								infoHtml: true,
								withSwitch: true,
								disabledClick: true,
								info: `
							<ul class="${classNames('list-disc list-inside')}">
								<li>Replace checkout with quick order form</li>
								<li>Creates Draft order for you to fullfill </li>
								<li>Skips all checkout payment options (example: Paypal, Shopify Payments, Afterpay)</li>
								<li>Creates customer orders/accounts for you to fullfill and collect payment for</li>
							</ul>
							`,
							},
						]}
						BindToContext={[shopContext, 'settings.cod_settings.is_active']}
						showCheckedIcon={false}
					/>
					{state.settings.cod_settings.is_active && (
						<>
							<FormControl
								label="Cash on delivery options"
								info="Would you like to give both checkout options or limit to just cash on delivery?"
								error={validationErrors['settings.cod_settings.checkout_mode']}
								isSingleCol={true}
							>
								<ButtonSelect
									options={[
										{ label: 'Cash on Delivery only', value: 'cod_only' },
										{ label: 'Checkout and cash on delivery', value: 'cod_and_checkout' },
									]}
									BindToContext={[shopContext, 'settings.cod_settings.checkout_mode']}
								/>
							</FormControl>
							<FormControl>
								<div>
									<Button
										text="Customize COD Checkout"
										onClick={() => {
											history.push('/settings/checkout' + location.search);
										}}
										style={{ width: '100%' }}
									/>
								</div>
							</FormControl>
						</>
					)}
					{ state.settings.cod_settings.checkout_mode == "cod_only" &&
						<FormControl
							label="one step checkout"
							withSwitch={[shopContext, 'settings.cod_settings.is_form_in_cart']}
							info="Display the checkout form in the main cart for a fast onr step checkout."
						/>
					}
					
				</FormGroup>
			</Fragment>
		</Page>
	);
};

export default CartScreen;
